module.exports = __webpack_public_path__ + "assets/61002a81b3607062fb24d8242c30da14.png";